import React, { useEffect } from "react";
import { ErrorMessage } from "@hookform/error-message";

const Radio = ({
  options,
  name,
  instruction,
  register,
  required,
  errors,
  type,
  builder,
  handleLinkForm,
  tabId,
  linkedTabs,
  getValues,
}: any) => {
  const styles = {
    flex: {
      display: "flex",
      gap: "10px",
    },
    wrapper: {
      marginBottom: "10px",
    },
    p: {
      margin: "5px",
      fontSize: "14px",
    },
    input: {
      margin: 0,
      width: "15px",
    },
  };

  const handleChange = (e: any) => {
    const { value } = e.target;
    const option =
      builder?.options?.find((opt: any) => opt.option === value) || {};
    const newBuilders =
      linkedTabs?.find((tab: any) => tab.id === option?.linkedToFormId)
        ?.builders || option?.linkedForm?.builders;
    handleLinkForm && handleLinkForm(tabId, newBuilders, builder?.id);
  };

  const initialValue = getValues(name);

  useEffect(() => {
    if (name && getValues) {
      if (initialValue) {
        handleChange({ target: { value: initialValue } });
      }
    }
  }, [getValues, name]);

  return (
    <div style={{ marginBottom: "20px" }}>
      <div style={styles.wrapper}>
        <p style={styles.p}>{instruction}</p>
        {options?.map((opt: any) => (
          <div
            style={styles.flex}
            key={opt.id}
          >
            <input
              style={styles.input}
              type={type}
              value={opt.option}
              defaultValue={initialValue}
              id={opt.id}
              {...register(name, {
                required: required ? `${instruction} is required` : false,
                onChange: (e: any) => handleChange(e),
              })}
            />
            <label htmlFor={opt.id}>{opt.option}</label>
          </div>
        ))}
      </div>
      <ErrorMessage
        errors={errors}
        name={name}
        as="span"
        className="error-form"
      />
    </div>
  );
};

export default Radio;
